import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const dropoffPhoneMachine = createTripArrayFieldMachine('dropoffPhone');
